import React, { Component, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { IIG_PATHS } from "../../constant";
import { iigBaseUrl } from "../../globalConfig";

export function ModalIIGUpdateProjectDisabled(props) {
  const { show, handleClose, iigProjectReferenceId } = props;

  return (
    <Modal
      show={show}
      onHide={handleClose}
      className="confirmation-modal iig-confirmation-modal"
    >
      <div class="confirm-icon" />
      <Modal.Header closeButton />
      <Modal.Body>
        <h4 class="page-heading">Update Project Details</h4>
        <p class="page-subline edit-project-for-iig">
          You'll be redirected to the CRIP (PAIMANA) Portal for updating the
          Project.
        </p>
        <div class="edit-project-iig-buttons justify-content-end d-flex">
          <div>
            <Button
              className="btn-orange-invert no-padding"
              onClick={handleClose}
            >
              Cancel
            </Button>
          </div>
          <div>
            <a
              target="_blank"
              href={
                iigBaseUrl +
                IIG_PATHS.IIG_PROJECT_UPDATE +
                // "?updateIIGProject=" +
                "?iigProject=" +
                iigProjectReferenceId
              }
            >
              <Button className="btn-orange no-padding">
                Go To CRIP Portal
              </Button>
            </a>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
